import React from 'react';
import { Navigate, useParams, useSearchParams } from 'react-router-dom';

/**
 * Legacy /:year/live → /dashboard with edition year preserved for event resolution.
 */
function YearLiveToDashboardRedirect() {
  const { year } = useParams();
  const [searchParams] = useSearchParams();
  const next = new URLSearchParams(searchParams);
  if (year) {
    next.set('year', String(year));
  }
  const qs = next.toString();
  return <Navigate to={qs ? `/dashboard?${qs}` : '/dashboard'} replace />;
}

export default YearLiveToDashboardRedirect;
